export default __webpack_public_path__ + "static/media/audio.7792572f.gif";